import { Typography } from "@mui/material"

const Contact = () => {
    return <Typography>Contacts</Typography>;
  };
  
  export default Contact;